<div class="modal-body identification-box modal-allow-overflow m-0 m-lg-3">
    <div class="mb-4">
        <h3>{{jobname}}</h3>
    </div>

    <app-performactioncertificateprovider [signatureProvider]="signatureProvider" [signatureProviderName]="signatureProviderName" [signatureProviders]="signatureProviders" (newSignMethod)="getNewSignMethod($event)"></app-performactioncertificateprovider>

    <app-user-identification-details></app-user-identification-details>

    <div class="mt-4 d-table w-100">
        <span class="float-start">
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="back();" translate="Button.Back"></button>
        </span>
        <span class="float-end">
            <button type="button" class="btn btn-sm btn-success ms-1 order-1 float-end" id="signBtn" [disabled]="disableSignButton()" (click)="startSignflow();" translate="Button.SignNow"></button>
        </span>
    </div>
</div>